"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.existsAndIsFileSync = void 0;
var fs_1 = __importDefault(require("fs"));
function existsAndIsFileSync(filepath) {
    return fs_1.default.existsSync(filepath) && fs_1.default.lstatSync(filepath).isFile();
}
exports.existsAndIsFileSync = existsAndIsFileSync;
